import { Button, Grid, Group, TextInput, NumberInput, Select } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';

import { transformDateFilter } from '@/shared/utils/helpers/datetime-format';
import { withdrawalStatusList, withdrawalStatusTitle } from '../utils/const/common';
import { CustomCollapse, useAppSelector, selectCurrencies } from '@/shared';

import type { TGetWithdrawalsParams } from '../store/types';

type FormData = TGetWithdrawalsParams;

type Props = {
  onSubmit: (data: TGetWithdrawalsParams) => void;
  onReset: () => void;
};

export const WithdrawalsFilter = (props: Props) => {
  const { onSubmit, onReset } = props;
  const avalableCurrencies = useAppSelector(selectCurrencies);

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {},
  });

  const handleSubmit = (values: FormData) => {
    const newValues: TGetWithdrawalsParams = {
      ...values,
      createdFrom: values.createdFrom ? transformDateFilter(values.createdFrom).dateFrom : undefined,
      createdTo: values.createdTo ? transformDateFilter(values.createdTo).dateTo : undefined,
    };

    onSubmit(newValues);
  };

  const handleReset = () => {
    form.reset();
    onReset();
  };

  return (
    <CustomCollapse title="Фильтр">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Первая секция */}
            <NumberInput
              label="ID вывода"
              key={form.key('id')}
              {...form.getInputProps('id')}
            />
            <Group justify='space-between' grow>
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (от)"
                clearable
                key={form.key('createdFrom')}
                {...form.getInputProps('createdFrom')}
              />
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (до)"
                clearable
                key={form.key('createdTo')}
                {...form.getInputProps('createdTo')}
              />
            </Group>
            <Group justify='space-between' grow>
              <TextInput
                label="Сумма (от)"
                key={form.key('amountFrom')}
                {...form.getInputProps('amountFrom')}
              />
              <TextInput
                label="Сумма (до)"
                key={form.key('amountTo')}
                {...form.getInputProps('amountTo')}
              />
            </Group>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Вторая секция */}
            <Select
              label="Валюта"
              clearable
              data={avalableCurrencies.map((currency) => ({ value: currency, label: currency }))}
              key={form.key('currency')}
              {...form.getInputProps('currency')}
            />
            <NumberInput
              label="ID магазина"
              key={form.key('shopId')}
              {...form.getInputProps('shopId')}
            />
            <NumberInput
              label="ID метода"
              key={form.key('methodId')}
              {...form.getInputProps('methodId')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Третья секция */}
            <Select
              label="Статус"
              clearable
              data={withdrawalStatusList.map((item) => ({ value: item, label: withdrawalStatusTitle[item] }))}
              key={form.key('status')}
              {...form.getInputProps('status')}
            />
            <Group justify="flex-end" mt="25">
              <Button variant="outline" onClick={handleReset}>
                Сбросить
              </Button>
              <Button type="submit">
                Отправить
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </form>
    </CustomCollapse>
  );
};
